import apiClient from './client'
import { ensureArray } from '../utils/array'

export interface Configuracao {
  id: number
  chave: string
  valor: string
  tipo: 'string' | 'integer' | 'float' | 'boolean' | 'json'
  descricao?: string | null
  categoria?: string | null
  editavel: boolean
  created_at?: string
  updated_at?: string
}

export interface ConfiguracaoCreate {
  chave: string
  valor: string
  tipo: 'string' | 'integer' | 'float' | 'boolean' | 'json'
  descricao?: string | null
  categoria?: string | null
  editavel: boolean
}

export interface ConfiguracaoUpdate {
  valor?: string | null
  descricao?: string | null
  categoria?: string | null
  editavel?: boolean | null
}

export const configuracoesApi = {
  list: async (categoria?: string): Promise<Configuracao[]> => {
    const params: Record<string, unknown> = {}
    if (categoria) {
      params.categoria = categoria
    }
    const response = await apiClient.get<Configuracao[]>('/config', { params })
    return ensureArray<Configuracao>(response.data)
  },

  get: async (chave: string): Promise<Configuracao> => {
    const response = await apiClient.get<Configuracao>(`/config/${chave}`)
    return response.data
  },

  create: async (data: ConfiguracaoCreate): Promise<Configuracao> => {
    const response = await apiClient.post<Configuracao>('/config', data)
    return response.data
  },

  update: async (chave: string, data: ConfiguracaoUpdate): Promise<Configuracao> => {
    const response = await apiClient.put<Configuracao>(`/config/${chave}`, data)
    return response.data
  },

  delete: async (chave: string): Promise<void> => {
    await apiClient.delete(`/config/${chave}`)
  },
}
